module.exports = __webpack_public_path__ + "static/media/external-light.e946a359.svg";